
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

interface AllBusinessesItemProps {
  onClick: (event: React.MouseEvent) => void;
  hide?: boolean;
  label?: string;
}

export const AllBusinessesItem: React.FC<AllBusinessesItemProps> = ({ 
  onClick,
  hide = false,
  label = "All Businesses"
}) => {
  if (hide) return null;
  
  return (
    <DropdownMenuItem 
      className="flex items-center gap-2 py-2 px-3 border-b border-gray-100 cursor-pointer font-medium text-brand-green" 
      onClick={onClick}
    >
      <ArrowLeft size={16} className="text-brand-green" />
      <span>{label}</span>
    </DropdownMenuItem>
  );
};
